
<div class="row">
    <!--
    <div class="col-md-1">
        &nbsp;
    </div>
-->
<div style="margin-top: 2em" class="col-md-10">
<p-card [header]="cardHeader">
    <div class="row">
        <div class="col-md-10 is-primary">
            <input type="checkbox" [(ngModel)]="chkIsPrimary" (change)="sendPrimary()"/> Practice is Primary
        </div>
    </div>
<div class="row row-align" >
    <div class="col-sm-5 col-md-5">
        <app-form-field [labelName]="'Practice Group'" [controlName]="findFormKey('practiceGroup')" [formGroup]="formGroup" [txtSize]="txtWidthTop"></app-form-field>
    </div>
    <div class="col-sm-1 col-md-1">
        &nbsp;
    </div>
    <div class="col-sm-5 col-md-5">
        <app-form-field [labelName]="'Office Name'" [controlName]="findFormKey('officeName')" [formGroup]="formGroup" [txtSize]="txtOfficeName"></app-form-field>
    </div>
</div>
<div class="row">
    <div class="col-sm-4 col-md-5">
        <app-form-field [labelName]="'Office Address'" [controlName]="findFormKey('officeAddress1')" [formGroup]="formGroup" [txtSize]="47"></app-form-field>
    </div>
    <div class="col-sm-1 col-md-1">
        &nbsp;
    </div>
    <div class="col-sm-6 col-md-6">
        <div class="shift-suite">
            <app-form-field [labelName]="'Suite #'" [controlName]="findFormKey('officeAddress2')" [formGroup]="formGroup" [txtSize]="10" ></app-form-field>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-sm-5 col-md-5">
        <div class="city-align">
            <app-form-field [labelName]="'City'" [controlName]="findFormKey('city')" [formGroup]="formGroup" [txtSize]="txtWidthCity" ></app-form-field>
        </div>
    </div>
    <div class="col-sm-3 col-md-3 drop-down-container">
        <div class="state-align">
            <app-drop-down [labelName]="'State'" [controlName]="findFormKey('state')" [formGroup]="formGroup" [whichDropDown]="2" [errorMessage]="'Select a State'"></app-drop-down>
        </div>
    </div>
    <div class="col-sm-3 col-md-3">
        <app-form-field [labelName]="'Zip'" [controlName]="findFormKey('zip')" [formGroup]="formGroup"  [txtSize]="8" [fieldOption]="8"></app-form-field>
    </div>
</div>
<div class="row">
    <div class="col-sm-3 col-md-4">
        <div class="phone-align">
            <app-form-field [fieldOption]="3" [labelName]="'Phone Number'" [controlName]="findFormKey('phoneNumber')" [formGroup]="formGroup" [txtSize]="15" ></app-form-field>
        </div>
    </div>
    <div class="col-sm-2 col-md-2">
        <div class="phone-ext-align">
                <app-form-field [labelName]="'Ext'" [controlName]="findFormKey('ext')" [formGroup]="formGroup" [txtSize]="5" [fieldOption]="9" [fieldLen]="5" ></app-form-field>
        </div>
    </div>
    <div class="col-sm-3 col-md-3">
        <div class="fax-align">
             <app-form-field [fieldOption]="3" [labelName]="'Fax Number'" [controlName]="findFormKey('fax')" [formGroup]="formGroup"  ></app-form-field>
        </div>
    </div>
    <div class="col-sm-3 col-md-3">
        <app-form-field [labelName]="'Email'" [controlName]="findFormKey('emailAddress')" [formGroup]="formGroup" [txtSize]="txtEmail" [isMEmailRequired]="chkIsPrimary"></app-form-field>
    </div>
</div>
</p-card>
</div>

</div>
<div class="row" >
    <div class="col-md-6 add-another">
        <div (click)="addNewLocale()"> + Add Practice</div>
    </div>
    <div class="col-md-6 add-another remove-align">
        <div (click)="removeNewLocale()" *ngIf="!chkIsPrimary"> - Remove Practice</div>
    </div>
</div>
